var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForm22Ico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 31,
    viewBox: "0 0 55 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9908 30.2225H0V18.1335C0 16.5304 0.807413 14.9929 2.24462 13.8594C3.68182 12.7258 5.63108 12.089 7.66359 12.089H15.3272V6.04449H0V0H15.3272C17.3597 0 19.309 0.63683 20.7462 1.77039C22.1834 2.90395 22.9908 4.44139 22.9908 6.04449V12.089C22.9908 13.6921 22.1834 15.2295 20.7462 16.3631C19.309 17.4966 17.3597 18.1335 15.3272 18.1335H7.66359V24.178H22.9908V30.2225Z",
    fill: "#473080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8653 30.2225H31.8745V18.1335C31.8745 16.5304 32.6819 14.9929 34.1191 13.8594C35.5563 12.7258 37.5056 12.089 39.5381 12.089H47.2017V6.04449H31.8745V0H47.2017C49.2342 0 51.1835 0.63683 52.6207 1.77039C54.0579 2.90395 54.8653 4.44139 54.8653 6.04449V12.089C54.8653 13.6921 54.0579 15.2295 52.6207 16.3631C51.1835 17.4966 49.2342 18.1335 47.2017 18.1335H39.5381V24.178H54.8653V30.2225Z",
    fill: "#473080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm22Ico);
export default __webpack_public_path__ + "static/media/form22Ico.bda973e4075e512abe4696a76ed61214.svg";
export { ForwardRef as ReactComponent };